import { useQuery } from '@tanstack/react-query';
import { getMerchantAPIUrl } from '../../services/apollo/urlResolver';
import { Country, CountriesResponse } from '../types/country';

const fetchCountries = async (): Promise<Country[]> => {
  const response = await fetch(`${getMerchantAPIUrl()}/countries/buyer`);

  if (!response.ok) {
    throw new Error('Failed to fetch countries');
  }

  const result: CountriesResponse = await response.json();
  return result.data;
};

export const useCountries = () => {
  return useQuery({
    queryKey: ['countries'],
    queryFn: fetchCountries,
  });
};
